import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { SortType } from "../carLine/carLineApi";

export interface IWorkSessionSetting {
 userId: number
  sessionTimeout: number
}

//
export const getInfoWorkSession = async ( ) => {
  const path = "workSessionSetting/infoWorkSession"
  const params = {
  }
  const result: ResponseSuccessTotal<IWorkSessionSetting> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//
export const addWorkSession = async (
 sessionTimeout:number
) => {
  const url = `workSessionSetting/addWorkSession`;
  const params = {
   sessionTimeout
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, paserParams(params, undefined)
  );
  return result;
}

